import { connect } from 'react-redux';
import { changePassword } from '../../../../redux/actions/user';
import EditPasswordModal from './EditPasswordModal';

const mapStateToProps = (state) => {
  return {
    status: state.user.status,
  };
};

const mapDispatchToProps = {
  changePassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPasswordModal);
